const $ = window.jQuery

window.jQuery(function() {
  window.jQuery.modal.defaults.showClose = false
})

Drupal.behaviors.galianModals = {
  attach(context, _settings) {
    if ($('body', context).length) {
      $('a[href="mailto:recrutement@galian-smabtp.fr"]').on('click', function (e) {
        if (!$(this).closest('.modal').length) {
          e.preventDefault()
          $('#open-apply-modal').modal()
        }
      })
    }
  },
}
